import { Markdown } from '@/components/Markdown';
import { useSimulatorState } from '@/store/useSimulatorState';

/**
 * Titre et description du scénario, affichés en tête de page avant les cartes.
 * Ne s'affiche que si au moins l'un des deux champs est renseigné (rétrocompat
 * des scénarios sans métadonnées). Purement descriptif.
 */
export function ScenarioHeading() {
  const info = useSimulatorState((s) => s.info);
  const title = info?.title?.trim();
  const description = info?.description?.trim();

  if (!title && !description) return null;

  return (
    <section className="flex flex-col gap-1.5 break-inside-avoid">
      {title && <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>}
      {description && (
        <Markdown className="max-w-3xl text-muted-foreground">{description}</Markdown>
      )}
    </section>
  );
}
